import { css } from 'styled-system/css';

export function RowGutter({
  n,
  active,
  soft,
}: {
  n: number;
  active?: boolean;
  soft?: boolean;
}) {
  return (
    <span
      data-active={active || undefined}
      data-soft={soft || undefined}
      className={css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'text.faint',
        background: 'bg.sunken',
        '&[data-soft]': {
          background: 'transparent',
        },
        '&[data-active]': {
          color: 'text.primary',
          background: 'bg.subtle',
        },
      })}
    >
      {n}
    </span>
  );
}
